// extracted by mini-css-extract-plugin
module.exports = {"Head":"Head_Head__209iL","row":"Head_row__2CqAj","col-12":"Head_col-12__2OESr","scrollDown":"Head_scrollDown__lWSVR"};